import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "api/axiosInstance";

export const fetchSuppliers = createAsyncThunk(
    "suppliers/list",
    async (filters = '', thunkAPI) => {
        try {
            const queryString = Object.keys(filters)
                .map((key) => `${key}=${filters[key]}`)
                .join("&");

            const { data } = await api.get(`/suppliers?${queryString}`);

            return thunkAPI.fulfillWithValue(data);
        } catch (err) {
            const message = err.response?.data?.error || err.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const suppliersSlice = createSlice({
    name: "suppliers",
    initialState: {
        suppliers: []
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSuppliers.fulfilled, (state, action) => {
                state.suppliers = action.payload.map(supplier => ({ value: supplier.id, label: supplier.name }))
            })
    }
});

export default suppliersSlice.reducer;
